export const AMEX = 'AMEX';
export const DISCOVER = 'DISCOVER';
export const MASTERCARD = 'MASTERCARD';
export const VISA = 'VISA';

//START GENAI@GHCOPILOT
/* added currently onboarded networks for VSB */
export const ONBOARDED_NETWORKS = [VISA, MASTERCARD];
//END GENAI@GHCOPILOT
